import type { Emphasis } from 'mdast';
import type { State } from '../state';

export function emphasis(state: State, node: Emphasis): void {
	if (!state.schema.marks.em) {
		// Gracefully degrade: render children as plain text when schema has no em mark
		state.parseTokens(node.children);
		return;
	}
	const mark = state.schema.marks.em.create();
	state.openMark(mark);
	state.parseTokens(node.children);
	state.closeMark(mark);
}
